import React from "react"

export const RocketBlastOffImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="680"
      height="192"
      viewBox="0 0 680 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2714_74654)">
        <rect width="680" height="192" fill="#EFE7FF" />
        <path
          d="M496 198V90C496 84.4772 491.523 80 486 80H477.962C474.92 80 471 80 467.955 80C467.955 83 467.955 87.5242 467.955 90.0098C467.955 94.3734 464.419 97.9109 460.057 97.9109H452.5C448.081 97.9109 444.5 101.493 444.5 105.911V114H432"
          stroke="#1D2B47"
        />
        <path d="M466.302 141.034H445H466.302Z" fill="white" />
        <path d="M466.302 141.034H445" stroke="#1D2B47" />
        <path d="M466.302 164.366H445H466.302Z" fill="white" />
        <path d="M466.302 164.366H445" stroke="#1D2B47" />
        <path d="M466.302 102.486V183.978V102.486Z" fill="white" />
        <path d="M466.302 102.486V183.978" stroke="#1D2B47" />
        <path
          d="M546 208V118.513C545.996 109.394 538.495 102.003 529.24 102H512.783C508.334 101.995 504.066 103.733 500.919 106.83C497.771 109.927 496.001 114.13 496 118.513V184.856"
          stroke="#1D2B47"
        />
        <path
          d="M247.705 176.011V58H265.774C271.31 58 275.798 62.4819 275.798 68.0107C275.798 72.3747 279.34 75.9125 283.71 75.9125H296.79"
          stroke="#1D2B47"
        />
        <path d="M277.669 95.7021H299H277.669Z" fill="white" />
        <path d="M277.669 95.7021H299" stroke="#1D2B47" />
        <path d="M277.669 119.034H299H277.669Z" fill="white" />
        <path d="M277.669 119.034H299" stroke="#1D2B47" />
        <path d="M277.669 142.366H299H277.669Z" fill="white" />
        <path d="M277.669 142.366H299" stroke="#1D2B47" />
        <path d="M277.669 80.4863V161.978V80.4863Z" fill="white" />
        <path d="M277.669 80.4863V161.978" stroke="#1D2B47" />
        <path
          d="M257.863 80.4863H266.327V88.9398H257.863V80.4863Z"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <path d="M262.094 66.9609V165.698V66.9609Z" fill="#1D2B47" />
        <path d="M262.094 66.9609V165.698" stroke="#1D2B47" />
        <path
          d="M229 186.422V152.317C229.001 148.842 231.822 146.025 235.301 146.023H241.489C243.162 146.022 244.767 146.684 245.95 147.864C247.134 149.045 247.799 150.646 247.8 152.317V177.602"
          stroke="#1D2B47"
        />
        <path
          d="M198 186V78C198 72.4772 193.523 68 188 68H179.962C174.435 68 169.955 72.4815 169.955 78.0098C169.955 82.3734 166.419 85.9109 162.057 85.9109H149"
          stroke="#1D2B47"
        />
        <path d="M198.302 85.1112H177H198.302Z" fill="white" />
        <path d="M198.302 85.1112H177" stroke="#1D2B47" />
        <path d="M198.302 105.111H177H198.302Z" fill="white" />
        <path d="M198.302 105.111H177" stroke="#1D2B47" />
        <path d="M198.302 125.111H177H198.302Z" fill="white" />
        <path d="M198.302 125.111H177" stroke="#1D2B47" />
        <path d="M168.302 129.034H147H168.302Z" fill="white" />
        <path d="M168.302 129.034H147" stroke="#1D2B47" />
        <path d="M168.302 152.366H147H168.302Z" fill="white" />
        <path d="M168.302 152.366H147" stroke="#1D2B47" />
        <path d="M168.302 90.4863V171.978V90.4863Z" fill="white" />
        <path d="M168.302 90.4863V171.978" stroke="#1D2B47" />
        <path
          d="M248 196V106.513C247.996 97.3944 240.495 90.0032 231.24 90H214.783C210.334 89.9954 206.066 91.7329 202.919 94.83C199.771 97.9271 198.001 102.13 198 106.513V172.856"
          stroke="#1D2B47"
        />
        <path
          d="M411.171 165.674V98.5537H425.965C429.371 98.5537 432.133 101.314 432.136 104.72V119.937C432.136 123.345 434.899 126.108 438.307 126.108C439.944 126.108 441.515 126.758 442.672 127.917C443.829 129.075 444.479 130.646 444.478 132.283V171.423"
          stroke="#1D2B47"
        />
        <path d="M411.171 112.704H397.815H411.171Z" fill="white" />
        <path d="M411.171 112.704H397.815" stroke="#1D2B47" />
        <path d="M411.171 126.112H397.815H411.171Z" fill="white" />
        <path d="M411.171 126.112H397.815" stroke="#1D2B47" />
        <path d="M411.171 139.519H397.815H411.171Z" fill="white" />
        <path d="M411.171 139.519H397.815" stroke="#1D2B47" />
        <path
          d="M432.305 169.394V152.065V134.735C432.305 133.521 433.289 132.537 434.503 132.537C435.717 132.537 436.701 133.521 436.701 134.735V175.312"
          stroke="#1D2B47"
        />
        <path
          d="M254.126 197.073C247.884 194.008 240.96 198.662 240.506 205.245C299.64 226.242 384.878 234.641 444.579 196.278C443.785 181.069 426.533 176.189 417.793 184.588C415.41 170.741 396.001 165.747 386.921 174.486C387.262 169.038 381.814 164.044 375.117 164.044C379.317 152.694 368.761 139.188 356.163 143.501C341.306 137.381 336.347 138.765 332.895 148.949C323.015 148.886 318.834 151.394 313.373 159.618C302.931 148.154 283.636 160.639 290.333 174.713C276.713 173.351 270.882 179.597 269.222 192.873C262.725 190.871 259.35 191.362 254.126 197.073Z"
          fill="white"
        />
        <path
          d="M357.238 150.547C357.233 144.146 352.24 138.859 345.85 138.487C339.46 138.116 333.889 142.79 333.143 149.147C325.044 147.936 317.093 152.11 313.491 159.465C308.786 154.478 301.178 153.592 295.453 157.365C289.728 161.139 287.542 168.48 290.271 174.77C285.257 173.561 279.967 174.717 275.914 177.906C271.861 181.095 269.494 185.966 269.491 191.123C269.491 191.123 269.491 199.492 272.196 202.705C269.491 205.405 270.674 211.501 272.872 212.168"
          stroke="#1D2B47"
        />
        <path
          d="M444.478 196.445C444.479 190.14 440.792 184.417 435.05 181.813C429.308 179.21 422.574 180.206 417.832 184.361C416.032 178.189 411.323 173.291 405.228 171.25C399.132 169.209 392.423 170.284 387.27 174.127C386.666 168.453 381.88 164.149 376.174 164.148C375.873 164.148 375.575 164.163 375.284 164.186C377.014 159.148 376.205 153.586 373.111 149.25C370.017 144.914 365.02 142.34 359.694 142.338"
          stroke="#1D2B47"
        />
        <path
          d="M269.785 193.117C264.429 190.257 257.78 191.878 254.341 196.881C251.407 195.463 247.949 195.654 245.189 197.386C242.428 199.117 240.751 202.147 240.749 205.406"
          stroke="#1D2B47"
        />
        <path
          d="M382.768 192.725C382.768 188.425 379.282 184.939 374.982 184.939C374.835 184.939 374.688 184.939 374.537 184.953C373.929 180.532 370.568 176.992 366.185 176.156C361.802 175.32 357.374 177.375 355.183 181.262C352.293 181.608 350.118 184.058 350.117 186.968"
          stroke="#1D2B47"
        />
        <path
          d="M311.58 190.366C311.58 188.8 310.678 187.373 309.262 186.702C307.847 186.03 306.172 186.233 304.958 187.223C303.258 186.234 301.16 186.229 299.456 187.209C297.751 188.19 296.701 190.006 296.702 191.973"
          stroke="#1D2B47"
        />
        <path
          d="M440.437 181.878C425.112 174.354 408.115 185.779 407 201.94C552.173 253.489 761.434 274.108 908 179.927C906.049 142.589 863.696 130.607 842.24 151.227C836.389 117.232 788.741 104.972 766.449 126.428C767.285 113.053 753.91 100.792 737.471 100.792C747.78 72.9282 721.866 39.7697 690.937 50.3581C667 28.5004 641.5 36.5002 633.815 63.733C609.56 63.5787 599.294 69.7356 585.889 89.9254C560.254 61.7825 512.884 92.4332 529.324 126.985C495.887 123.641 481.572 138.976 477.497 171.568C461.547 166.653 453.26 167.858 440.437 181.878Z"
          fill="white"
        />
        <path
          d="M693.576 67.656C693.565 51.9425 681.307 38.9617 665.62 38.0507C649.933 37.1397 636.254 48.6143 634.424 64.2208C614.54 61.2459 595.02 71.4943 586.178 89.5507C574.627 77.3065 555.948 75.1322 541.894 84.396C527.839 93.6597 522.473 111.683 529.172 127.125C516.864 124.157 503.875 126.994 493.926 134.824C483.977 142.653 478.165 154.611 478.157 167.272C478.157 167.272 478.157 187.818 484.798 195.704C478.157 202.334 481.062 217.298 486.458 218.937"
          stroke="#1D2B47"
        />
        <path
          d="M478.878 172.166C465.731 165.145 449.407 169.124 440.965 181.407C433.76 177.927 425.273 178.395 418.495 182.646C411.717 186.897 407.6 194.334 407.596 202.335"
          stroke="#1D2B47"
        />
        <path
          d="M581.487 165.415C581.486 161.569 579.271 158.067 575.797 156.417C572.322 154.768 568.208 155.267 565.228 157.698C561.056 155.27 555.905 155.257 551.721 157.664C547.537 160.071 544.959 164.531 544.961 169.358"
          stroke="#1D2B47"
        />
        <path
          d="M727.157 146.13C727.157 135.573 718.599 127.015 708.042 127.015C707.682 127.015 707.321 127.015 706.95 127.048C705.458 116.195 697.207 107.505 686.447 105.453C675.686 103.401 664.816 108.445 659.436 117.988C652.342 118.836 647.002 124.852 647 131.996"
          stroke="#1D2B47"
        />
        <path
          d="M330.819 98.5361L317.249 108.175C310.272 113.479 307.369 122.762 310.039 131.244L319.271 160.609C319.271 160.609 319.271 137.404 331.964 133.509C344.658 129.614 330.819 98.5361 330.819 98.5361V98.5361Z"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <path
          d="M365.567 98.5361L379.137 108.175C386.113 113.479 389.016 122.762 386.347 131.244L377.115 160.609C377.115 160.609 377.115 137.404 364.421 133.509C351.728 129.614 365.567 98.5361 365.567 98.5361Z"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <path
          d="M361.485 142.648L359.482 143.678C353.07 146.976 345.457 146.968 339.052 143.655L337.105 142.648V126.105H361.485V142.648Z"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <path
          d="M331.942 133.308L324.378 70.9705C322.636 59.9054 325.731 48.6252 332.874 39.9974L348.876 20.6745C348.958 20.5745 349.08 20.5166 349.209 20.5166C349.339 20.5166 349.461 20.5745 349.543 20.6745L365.631 40.0285C372.783 48.6331 375.899 59.8933 374.187 70.9504L366.675 133.684L366.176 134.129C356.556 142.568 342.142 142.473 332.634 133.907L331.942 133.308Z"
          fill="#B99BF9"
          stroke="#1D2B47"
        />
        <path d="M349.296 58.293V105.114" stroke="#1D2B47" />
        <path
          d="M353.865 109.038L349.303 165.674L344.742 109.043C344.569 106.912 346.662 105.107 349.303 105.107C351.945 105.103 354.037 106.907 353.865 109.038Z"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <circle
          cx="349.296"
          cy="77.1571"
          r="14.2196"
          fill="white"
          stroke="#1D2B47"
        />
        <circle
          cx="349.296"
          cy="77.1573"
          r="10.2599"
          fill="#2B5FCE"
          stroke="#1D2B47"
        />
        <path
          d="M350.773 67.0049L339.995 81.4893C340.694 82.9843 341.741 84.2897 343.049 85.2955L355.298 68.8335C353.96 67.8662 352.408 67.2386 350.773 67.0049V67.0049Z"
          fill="white"
        />
        <path
          d="M347.841 87.3125L358.608 72.8526C358.247 72.0762 357.791 71.3477 357.251 70.6836L345.374 86.6429C346.165 86.9692 346.994 87.1942 347.841 87.3125Z"
          fill="white"
        />
        <circle cx="349.296" cy="77.1573" r="10.2599" stroke="#1D2B47" />
        <path
          d="M325.306 54.4951C325.306 54.4951 349.296 62.9352 372.705 54.7176"
          stroke="#1D2B47"
        />
        <path
          d="M362.466 82.5253L368.644 81.7021L367.289 99.8905L370.715 99.8638"
          stroke="#1D2B47"
        />
        <path
          d="M368.644 81.7022C368.644 81.7022 370.675 63.4204 369.035 55.8701"
          stroke="#1D2B47"
        />
        <path
          d="M367.289 99.8906L364.871 125.631C364.871 125.631 358.695 130.345 352.157 130.261"
          stroke="#1D2B47"
        />
        <path
          d="M349.303 95.8799C349.303 95.8799 341.652 98.0511 333.528 94.7676"
          stroke="#1D2B47"
        />
        <path
          d="M325.306 77.8252C325.306 77.8252 330.044 81.2199 332.269 80.4458C332.754 86.6368 335.074 110.404 335.074 110.404C335.074 110.404 330.605 110.727 328.932 108.449"
          stroke="#1D2B47"
        />
        <path d="M349.296 20.759V0.831055" stroke="#1D2B47" />
        <path
          d="M484.869 28.2763C484.869 24.5164 486.23 20.877 488.713 18C481.199 18.3166 474.865 23.5697 473.342 30.7497C471.818 37.9298 475.494 45.201 482.263 48.3976C489.032 51.5943 497.164 49.8992 502 44.2833C501.765 44.2833 501.529 44.2833 501.297 44.2833C496.941 44.2851 492.762 42.5995 489.681 39.5974C486.6 36.5953 484.869 32.5228 484.869 28.2763Z"
          fill="#1947AA"
          stroke="#1D2B47"
        />
        <circle
          cx="285.363"
          cy="28.6447"
          r="3.35372"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <circle
          cx="456.354"
          cy="111.354"
          r="3.35372"
          fill="#1D2B47"
          stroke="#1D2B47"
        />
        <path d="M406.462 18V25.1449V18Z" fill="#1D2B47" />
        <path d="M406.462 18V25.1449" stroke="#1D2B47" />
        <path d="M402.889 21.5727H410.034H402.889Z" fill="#1D2B47" />
        <path d="M402.889 21.5727H410.034" stroke="#1D2B47" />
        <path d="M453.572 60V67.1449V60Z" fill="#1D2B47" />
        <path d="M453.572 60V67.1449" stroke="#1D2B47" />
        <path d="M450 63.5727H457.145H450Z" fill="#1D2B47" />
        <path d="M450 63.5727H457.145" stroke="#1D2B47" />
        <path d="M200.573 28.499V35.6439V28.499Z" fill="#1D2B47" />
        <path d="M200.573 28.499V35.6439" stroke="#1D2B47" />
        <path d="M197 32.0708H204.145H197Z" fill="#1D2B47" />
        <path d="M197 32.0708H204.145" stroke="#1D2B47" />
        <path
          d="M-212.362 195.505C-228.237 187.711 -245.845 199.546 -247 216.288C-96.6112 269.689 120.168 291.05 272 193.485C269.979 154.805 226.104 142.393 203.878 163.753C197.816 128.537 148.456 115.837 125.364 138.063C126.23 124.208 112.374 111.507 95.3438 111.507C107.687 82.959 76.5258 47.1575 43.0599 57.8538C23.8952 35.5812 -5.11075 46.9765 -12.0356 73.1158C-37.1624 72.9559 -47.7971 79.334 -61.6841 100.249C-88.2402 71.0952 -137.311 102.847 -120.281 138.64C-154.919 135.176 -169.749 151.062 -173.971 184.825C-190.494 179.733 -199.078 180.982 -212.362 195.505Z"
          fill="white"
        />
        <path
          d="M49.8726 77.1805C49.8605 60.9024 37.1621 47.4552 20.9114 46.5115C4.66081 45.5677 -9.50883 57.4546 -11.4051 73.6218C-32.0034 70.5401 -52.2248 81.1566 -61.3846 99.8619C-73.3504 87.1777 -92.7001 84.9253 -107.26 94.5219C-121.819 104.118 -127.378 122.789 -120.439 138.786C-133.189 135.712 -146.644 138.651 -156.951 146.762C-167.258 154.872 -173.278 167.26 -173.287 180.375C-173.287 180.375 -173.287 201.659 -166.407 209.829C-173.287 216.697 -170.277 232.199 -164.687 233.897"
          stroke="#1D2B47"
        />
        <path
          d="M271.742 193.908C271.745 177.874 262.367 163.32 247.764 156.698C233.162 150.076 216.035 152.609 203.975 163.176C199.399 147.481 187.423 135.023 171.92 129.832C156.417 124.641 139.355 127.376 126.25 137.151C124.714 122.721 112.542 111.773 98.0302 111.771C97.2664 111.771 96.5083 111.81 95.7671 111.867C100.167 99.056 97.3079 85.4385 90.241 73.8825C81.3893 59.4079 54.914 52.0453 43.5779 57.8541"
          stroke="#1D2B47"
        />
        <path
          d="M114.8 184.449C114.8 173.513 105.935 164.647 94.9984 164.647C94.625 164.647 94.2516 164.647 93.8669 164.681C92.3219 153.439 83.7745 144.436 72.6272 142.31C61.4799 140.185 50.2194 145.41 44.6456 155.295C37.2973 156.174 31.7652 162.406 31.7632 169.807"
          stroke="#1D2B47"
        />
      </g>
      <defs>
        <clipPath id="clip0_2714_74654">
          <rect width="680" height="192" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
